import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { Settings } from '@mui/icons-material';

export default function ReceptionSettings() {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Setări receptie</Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Settings sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">Read-only pentru receptie, edit pentru admin</Typography>
      </Paper>
    </Box>
  );
}
